import { Route } from "react-router-dom";
import {
  LeaseApplicationPageAction,
  LeaseApplicationPageLoader,
  LeaseApplicationPageErrorBoundary,
} from "./LeaseApplicationPage/loaders";
import { LeaseApplicationPage } from "./LeaseApplicationPage";
import {
  LeaseListPageErrorBoundary,
  LeaseListPageLoader,
} from "./LeaseListPage/loaders";
import { LeaseListPage } from "./LeaseListPage";
import { LeaseDetailsPage } from "./LeaseInfoPage";
import {
  LeaseDetailsPageAction,
  LeaseDetailsPageErrorBoundary,
  LeaseDetailsPageLoader,
} from "./LeaseInfoPage/loaders";
import { ProtectedRoute } from "~/context/ProtectedRoute";
import * as APITypes from "~/API";
import { ROUTES } from "~/utils";
import { GenericErrorBoundary } from "~/components";
import {
  LeaseRenewalPageAction,
  LeaseRenewalPageLoader,
} from "./LeaseRenewalPage/loaders";
import { LeaseRenewalPage } from "./LeaseRenewalPage";
import { leaseListRouteHandle } from "~/components/Layout/Fallbacks/routeContentFallbackRegistry";

export const LeasePagesRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.leaseApplication}
        loader={LeaseApplicationPageLoader}
        action={LeaseApplicationPageAction}
        ErrorBoundary={LeaseApplicationPageErrorBoundary}
        element={
          <ProtectedRoute
            roles={[
              APITypes.TenantStatusType.Active,
              APITypes.TenantStatusType.InActive,
            ]}
          >
            <LeaseApplicationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.lease}
        loader={LeaseListPageLoader}
        handle={leaseListRouteHandle}
        ErrorBoundary={LeaseListPageErrorBoundary}
        element={
          <ProtectedRoute
            roles={[
              APITypes.TenantStatusType.Active,
              APITypes.TenantStatusType.InActive,
            ]}
          >
            <LeaseListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.leaseDetails}
        loader={LeaseDetailsPageLoader}
        action={LeaseDetailsPageAction}
        ErrorBoundary={LeaseDetailsPageErrorBoundary}
        element={
          <ProtectedRoute
            roles={[
              APITypes.TenantStatusType.Active,
              APITypes.TenantStatusType.InActive,
            ]}
          >
            <LeaseDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.leaseRenewalPage}
        action={LeaseRenewalPageAction}
        loader={LeaseRenewalPageLoader}
        ErrorBoundary={GenericErrorBoundary}
        element={
          <ProtectedRoute roles={[APITypes.TenantStatusType.Active]}>
            <LeaseRenewalPage />
          </ProtectedRoute>
        }
      />
    </>
  );
};
